

import React, { memo } from 'react';
import { FormModal, Text } from '../../../ui-kit';
import FooterButtons from './FooterButtons';
import '../styles/_shutter-stock-modal.scss';

const HELP_LINK = 'https://shootsta.com/#form-block';






const ShutterStockModal = ({
  visible,
  onClose
}) => {
  const onClickHelpLink = () => window.open(HELP_LINK, '_blank');

  const videoUrl = 'https://shootsta-resources.s3.ap-southeast-2.amazonaws.com/shutterstock-unlimited.mp4';

  return (
    <FormModal
      className="shutter-stock-modal__form"
      visible={visible}
      onClose={onClose}
      title="Access millions of stock assets. Unlimited."
      showCancelBtn={false}
      showExtraButtons
      footerExtraButtons={FooterButtons({ onClickHelpLink })}
      size="MD">

      <div className="shutter-stock-modal__content">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video className="shutter-stock-modal__video" src={videoUrl} controls />
        <Text className="shutter-stock-modal__description">
          Need more ways to create great video content? With Shootsta Stock Unlimited,
          you can add as many assets as you need without any ad-hoc costs.
          No more worrying about licensing fees or restrictions, just unlimited creativity!
        </Text>
        <Text>
          Reach out and get onboard!
        </Text>
      </div>
    </FormModal>);

};

export default memo(ShutterStockModal);